import { PopularSearches } from './PopularSearches';
import { CitySeoIndex } from './CitySeoIndex';
import { CityDetail } from './CityDetail';
import { CityCard } from './CityCard';


import { guadeloupeCity } from '../../data/mock';
import { citySlug } from '../../lib/citySlug';

export const CitiesSection = ({ handleWhatsAppClick }) => (
<section id="villes" className="py-12 md:py-16 bg-black">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="inline-block bg-red-600/20 border border-red-600/40 text-red-400 px-6 py-2 rounded-full text-sm font-semibold mb-6">
              📍 Présent dans Toute la Guadeloupe
            </span>
            <h2 className="text-4xl md:text-6xl font-bold mb-6 text-red-600 leading-tight">
              Marabout Sorcier Vaudou dans Toutes les Villes de Guadeloupe
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-4xl mx-auto leading-relaxed">
              Le grand <strong className="text-white">marabout sorcier vaudou Maître Diamma</strong> intervient rapidement dans toutes les villes 
              et communes de Guadeloupe pour vos urgences de <strong className="text-red-400">retour affectif</strong>, désenvoutement, 
              rituels de magie blanche, magie rouge et voyance. Consultations sur place ou à distance par WhatsApp.
            </p>
          </div>

          <div className="max-w-7xl mx-auto">
            <div className="city-directory grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-16">
              {guadeloupeCity.map((city) => (
                <CityCard key={citySlug(city)} city={city} />
              ))}
            </div>

            {/* SEO Content DÉTAILLÉ par ville - TOUTES LES 30 VILLES */}
            <div className="city-details grid grid-cols-1 gap-6 mb-12">
              {guadeloupeCity.map((city) => (
                <CityDetail key={citySlug(city)} city={city} handleWhatsAppClick={handleWhatsAppClick} />
              ))}
            </div>

            <CitySeoIndex />
            
            {/* Section Keywords Longue Traîne */}
            <PopularSearches />
          </div>
        </div>
      </section>
);
